// extracted by mini-css-extract-plugin
export var askAiIcon = "_mj-9";
export var container = "_mj-0";
export var groupSeparator = "_mj-a";
export var highlight = "_mj-4";
export var resultIcon = "_mj-5";
export var resultItem = "_mj-7";
export var resultSubtitle = "_mj-3";
export var resultTitle = "_mj-2";
export var resultsList = "_mj-1";
export var searchGroup = "_mj-6";
export var selected = "_mj-8";